var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHonestconversations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22.487 12.53a.518.518 0 0 1-.505-.53c0-.292.226-.53.505-.53.278 0 .504.238.504.53 0 .292-.226.53-.504.53zm-8.07-8.471c.278 0 .504.237.504.53 0 .291-.226.529-.504.529a.518.518 0 0 1-.504-.53c0-.292.225-.53.504-.53zM5.338 9.353a.518.518 0 0 1-.504-.53c0-.292.226-.529.504-.529.279 0 .505.237.505.53 0 .292-.226.529-.505.529zm18.36 2.159a1.127 1.127 0 0 1 0 1.535l-7.275 7.636a1.002 1.002 0 0 1-1.462 0l-2.233-2.344 1.228-1.288h1.643c.852 0 1.55-.732 1.55-1.626v-7.73l.724-.762a1.004 1.004 0 0 1 1.463 0l4.362 4.579zm-10.97.821L12 11.57 7.881 7.247V4.085C7.881 3.488 8.346 3 8.915 3h6.17c.569 0 1.034.488 1.034 1.085v10.8c0 .596-.465 1.085-1.034 1.085h-.266a1.686 1.686 0 0 0-.325-1.783l-1.766-1.854zm.758 3.637c-.03.044-.048.095-.085.135l-.9.946-.501.525-.728.763-2.233 2.344a1.002 1.002 0 0 1-1.462 0L.302 13.047a1.127 1.127 0 0 1 0-1.535l4.362-4.579a1.004 1.004 0 0 1 1.463 0l.724.762 1.03 1.08 3.39 3.558.729.766 1.401 1.47c.364.383.381.977.085 1.401z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHonestconversations);
export default __webpack_public_path__ + "static/media/honestconversations.969b8179bdf96eb482ba461ecd9069a0.svg";
export { ForwardRef as ReactComponent };